import { isEqual } from 'lodash';
export default function getArrayOverlap(arr1, arr2) {
    if (Array.isArray(arr1) && Array.isArray(arr2)) {
        return arr1.filter(a1 => arr2.some(a2 => isEqual(a1, a2)));
    }
    return arr1.filter(a1 => arr2.includes(a1));
}
